
import { Typography } from '@material-ui/core'
import { Button } from 'antd'
import React, { useRef } from 'react'
import ReactToPrint from 'react-to-print'

export default function ReceiptPrint({data}) {
    const componentRef = useRef()
  return (
   <div>
    <div style={{textAlign: "center", marginBottom: 20}}>
    <ReactToPrint
              trigger={() => (
                <Button type="primary">
                  Print Receipt
                </Button>
              )}
              
              content={() => componentRef.current}
              pageStyle={{ margin: "10px" }}
              copyStyles={true}
            />
    </div>
     <div style={{margin: 10}} ref={componentRef}>
         <table width="100%">
          <tbody>
            <tr>
              <td width="20%">
                <img
                  alt="logo"
                  src={"/icon512.png"}
                  style={{ width: "60px" }}
                />
              </td>

              <td width="60%" align="center">
                <Typography variant="h5">
                  Dispur College
                </Typography>
                <Typography variant="body2">
                Guwahati -781 006 , Assam, India
                </Typography>
                <Typography variant="body2"> 0361 - 3513202, 0361 - 3515332 | dispurcollege1978@gmail.com</Typography>
                <Typography variant="body1">Payment Receipt</Typography>
              </td>

              <td width="20%" align="center">
               
              </td>
            </tr>
          </tbody>
        </table>

        <br />
        <br />

        <table className="table">
          <tbody>
            <tr>
              <td width="30%">
                <Typography variant="body2">Name</Typography>
              </td>

              <td>
                <Typography variant="body2">{data.name}</Typography>
              </td>
            </tr>

            <tr>
              <td width="30%">
                <Typography variant="body2">Certificate Type</Typography>
              </td>

              <td>
                <Typography variant="body2">{data.type_name}</Typography>
              </td>
            </tr>

            <tr>
              <td width="30%">
                <Typography variant="body2">Transaction Status</Typography>
              </td>

              <td>
                <Typography variant="body2">Success</Typography>
              </td>
            </tr>

            

            <tr>
              <td width="30%">
                <Typography variant="body2">Date of Application</Typography>
              </td>

              <td>
                <Typography variant="body2">{data.date_of_application}</Typography>
              </td>
            </tr>

            <tr>
              <td width="30%">
                <Typography variant="body2">Amount</Typography>
              </td>

              <td>
                <Typography variant="body2">
                  {data.amount_paid}
                </Typography>
              </td>
            </tr>

            <tr>
              <td width="30%">
                <Typography variant="body2">Date of Payment</Typography>
              </td>

              <td>
                <Typography variant="body2">{data.amount_paid_on}</Typography>
              </td>
            </tr>

            

            <tr>
              <td width="30%">
                <Typography variant="body2">Transaction ID</Typography>
              </td>

              <td>
                <Typography variant="body2">
                  {data.transaction_id}
                </Typography>
              </td>
            </tr>

            <tr>
              <td width="30%">
                <Typography variant="body2">Order No</Typography>
              </td>

              <td>
                <Typography variant="body2">
                  {data.order_req ? data.order_req.order_id : "--"}
                </Typography>
              </td>
            </tr>
          </tbody>
        </table>
    </div>
   </div>
  )
}
